import { render, staticRenderFns } from "./PartnerAgreement.vue?vue&type=template&id=94f6edc6&scoped=true"
import script from "./PartnerAgreement.vue?vue&type=script&lang=js"
export * from "./PartnerAgreement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94f6edc6",
  null
  
)

export default component.exports